mutation updateLeadsPipelineStatus($input: UpdateLeadsPipelineStatusInput!) {
  updateLeadsPipelineStatus(input: $input) {
    id
    companyId
    name
    position
  }
}
